<template>
  <div class="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100" :dir="dir">
    <Navbar />

    <main class="flex-1 flex items-center justify-center px-4 py-16 sm:py-24">
      <div class="max-w-xl w-full text-center">
        <!-- 404 Badge Illustration -->
        <div class="relative inline-flex items-center justify-center mb-6">
          <div class="absolute inset-0 rounded-full bg-emerald-500/10 dark:bg-emerald-500/20 blur-2xl transform scale-150"></div>
          <div class="relative w-28 h-28 sm:w-36 sm:h-36 rounded-3xl bg-gradient-to-tr from-emerald-500/20 via-emerald-500/10 to-teal-500/20 dark:from-emerald-500/30 dark:to-teal-500/10 border border-emerald-500/20 flex flex-col items-center justify-center shadow-lg">
            <span class="text-4xl sm:text-5xl font-extrabold tracking-tight text-emerald-600 dark:text-emerald-400">404</span>
            <i class="mdi mdi-file-search-outline text-2xl sm:text-3xl text-emerald-600/80 dark:text-emerald-400/80 mt-1"></i>
          </div>
        </div>

        <!-- Headings -->
        <h1 class="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight mb-3">
          {{ lang === 'ar' ? 'الصفحة أو الاستشارة غير موجودة' : 'Page or Consultation Not Found' }}
        </h1>

        <p class="text-sm sm:text-base text-slate-600 dark:text-slate-400 max-w-md mx-auto mb-8 leading-relaxed">
          {{
            lang === 'ar'
              ? 'عذراً، لم نتمكن من العثور على الاستشارة أو الصفحة المطلوبة. قد تكون حُذفت أو أن الرابط غير صحيح.'
              : 'Sorry, we could not find the requested consultation or page. It may have been deleted, or the link is invalid.'
          }}
        </p>

        <!-- Action CTAs -->
        <div class="flex flex-wrap items-center justify-center gap-3">
          <router-link
            to="/consultations/my"
            class="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold shadow-sm transition transform hover:-translate-y-0.5"
          >
            <i class="mdi mdi-format-list-bulleted"></i>
            <span>{{ lang === 'ar' ? 'استشاراتي' : 'My Consultations' }}</span>
          </router-link>

          <router-link
            to="/dashboard"
            class="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-750 text-slate-700 dark:text-slate-200 text-sm font-medium shadow-2xs transition transform hover:-translate-y-0.5"
          >
            <i class="mdi mdi-view-dashboard-outline"></i>
            <span>{{ lang === 'ar' ? 'لوحة التحكم' : 'Dashboard' }}</span>
          </router-link>

          <router-link
            to="/"
            class="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 text-sm font-medium transition"
          >
            <i class="mdi mdi-home-outline"></i>
            <span>{{ lang === 'ar' ? 'الرئيسية' : 'Home' }}</span>
          </router-link>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { usePageI18n } from "@/composables/usePageI18n";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

const { lang, dir } = usePageI18n();
</script>
